import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

export const SuccessIcon = () => <CheckCircleTwoTone twoToneColor="#52c41a" />;
export const FailedIcon = () => <CloseCircleTwoTone twoToneColor="#c41a52" />;
